import type { Resource } from "@ferrivia/i18n";
import fi from "./locales/fi.json";
import en from "./locales/en.json";
import enUs from "./locales/en.us.json";

export const authWebResources: Resource = {
  fi: { auth: fi },
  en: { auth: en },
};

export const authWebUsOverlay: Resource = {
  en: { auth: enUs },
};
